export default __webpack_public_path__ + "static/bunker-phones-1-mobile-d9ce80795d0d6769ab52b81f314cc584.jpg";